import {FC, useState, createContext, useContext} from 'react'
import {
    QueryState,
    QueryRequestContextProps,
    initialQueryRequest,
    WithChildren,
} from '../../../../../_metronic/helpers'

const DLMSiteInspectionsQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMSiteInspectionsQueryRequestProvider: FC<WithChildren> = ({children}) => {
    const [state, setState] = useState<QueryState>(initialQueryRequest.state)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return (
    <DLMSiteInspectionsQueryRequestContext.Provider value={{state, updateState}}>
        {children}
    </DLMSiteInspectionsQueryRequestContext.Provider>
    )
}

const useDLMSiteInspectionsQueryRequest = () => useContext(DLMSiteInspectionsQueryRequestContext)
export {DLMSiteInspectionsQueryRequestProvider, useDLMSiteInspectionsQueryRequest}
